import React from "react";

export default function Loader({ isDisabled }) {

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const spinnerStyle = {
    color: "#fff",
    fontSize: "24px",
  };
  
  return (
    <>
      {isDisabled && (
        <div style={overlayStyle}>
          <div style={spinnerStyle}>Loading...</div>
        </div>
      )}
    </>
  );
}
